import React, { useState } from "react";
import {
  Menu,
  MenuItem,
  Icon,
  IconButton,
  Tooltip,
  useTheme,
} from "@material-ui/core";
import NestedMenuItem from "material-ui-nested-menu-item";
import { ColorPicker } from "material-ui-color";
import { useTranslation } from "react-i18next";

import { useStyles, commonIcon } from "./HomeCardStyles";
import {
  DASHBOARD_CARD_EXTRA,
  DASHBOARD_CARD_EXTRA_LARGE,
  DASHBOARD_CARD_LARGE,
  DASHBOARD_CARD_MEDIUM,
  DASHBOARD_CARD_SMALL,
} from "../../../../util/Constants";
import {
  useAccessesStore,
  INTRUCTIONS,
} from "../../../../core/stores/AccessesStore";

const itemsIconStyles = {
  width: "auto",
  height: "auto",
  padding: 1,
  marginLeft: 3,
  fontSize: "0.75rem",
};

export const OptionsCard = (props) => {
  const {
    currentSize,
    cardIndex,
    sectionIndex,
    hidden,
    isKpi,
    sectionHidden,
    color,
    itemsLength,
  } = props;

  const { t } = useTranslation();
  const muiTheme = useTheme();
  const classes = useStyles();
  const [menuPosition, setMenuPosition] = useState(null);
  const [newColor, setNewColor] = useState(color || null);

  const {
    changeSizeOfCard,
    changeHiddenOfCard,
    changeColorOfCard,
    orderItem,
    deleteItemOfBand,
  } = useAccessesStore((state) => ({
    changeSizeOfCard: state.changeSizeOfCard,
    changeHiddenOfCard: state.changeHiddenOfCard,
    changeColorOfCard: state.changeColorOfCard,
    orderItem: state.orderItem,
    deleteItemOfBand: state.deleteItemOfBand,
  }));

  const handleButtonClick = (event) => {
    if (menuPosition || sectionHidden) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.pageY,
      left: event.pageX,
    });
  };

  const handleHidden = () => {
    changeHiddenOfCard({ sectionIndex, cardIndex, newHidden: !hidden });
    setMenuPosition(null);
  };

  const handleDeleteItem = () => {
    deleteItemOfBand({ sectionIndex, cardIndex });
    setMenuPosition(null);
  };

  const handleChangeSizeClick = (currentSize, newSize) => {
    if (currentSize !== newSize) {
      changeSizeOfCard({ sectionIndex, cardIndex, newSize });
    }
    setMenuPosition(null);
  };

  const handleChangeColorCard = (colorToSet) => {
    if (newColor !== colorToSet) {
      changeColorOfCard({ sectionIndex, cardIndex, newColor: colorToSet });
    }
    setNewColor(colorToSet);
    setMenuPosition(null);
  };

  const handleMoveItem = (e, instruction) => {
    orderItem({
      sectionIndex,
      cardIndex,
      instruction,
    });
    setMenuPosition(null);
  };

  return (
    <div>
      <Tooltip
        title={sectionHidden ? t("CUSTOM_HOME_CARD_OPTIONS_DISABLED") : ""}
        disableHoverListener={!sectionHidden}
      >
        <IconButton onClick={handleButtonClick} className={classes.cardEditBtn}>
          <Icon className="fas fa-ellipsis-v" style={commonIcon} />
        </IconButton>
      </Tooltip>
      <Menu
        open={!!menuPosition}
        onClose={() => setMenuPosition(null)}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition}
      >
        <MenuItem onClick={handleHidden}>
          {hidden
            ? t("CUSTOM_HOME_CARD_OPTIONS_SHOW")
            : t("CUSTOM_HOME_CARD_OPTIONS_HIDE")}
          <Icon
            className={hidden ? "fas fa-eye" : "fas fa-eye-slash"}
            style={itemsIconStyles}
          />
        </MenuItem>
        <NestedMenuItem
          label={t("CUSTOM_HOME_CARD_OPTIONS_SIZE")}
          parentMenuOpen={!!menuPosition}
        >
          {!isKpi && (
            <MenuItem
              onClick={() =>
                handleChangeSizeClick(currentSize, DASHBOARD_CARD_SMALL)
              }
              className={
                currentSize === DASHBOARD_CARD_SMALL
                  ? classes.selectedOption
                  : ""
              }
            >
              {DASHBOARD_CARD_SMALL}
            </MenuItem>
          )}
          {!isKpi && (
            <MenuItem
              onClick={() =>
                handleChangeSizeClick(currentSize, DASHBOARD_CARD_MEDIUM)
              }
              className={
                currentSize === DASHBOARD_CARD_MEDIUM
                  ? classes.selectedOption
                  : ""
              }
            >
              {DASHBOARD_CARD_MEDIUM}
            </MenuItem>
          )}
          <MenuItem
            onClick={() =>
              handleChangeSizeClick(currentSize, DASHBOARD_CARD_LARGE)
            }
            className={
              currentSize === DASHBOARD_CARD_LARGE ? classes.selectedOption : ""
            }
          >
            {DASHBOARD_CARD_LARGE}
          </MenuItem>
          {isKpi && (
            <MenuItem
              onClick={() =>
                handleChangeSizeClick(currentSize, DASHBOARD_CARD_EXTRA)
              }
              className={
                currentSize === DASHBOARD_CARD_EXTRA
                  ? classes.selectedOption
                  : ""
              }
            >
              {DASHBOARD_CARD_EXTRA}
            </MenuItem>
          )}
          {isKpi && (
            <MenuItem
              onClick={() =>
                handleChangeSizeClick(currentSize, DASHBOARD_CARD_EXTRA_LARGE)
              }
              className={
                currentSize === DASHBOARD_CARD_EXTRA_LARGE
                  ? classes.selectedOption
                  : ""
              }
            >
              {DASHBOARD_CARD_EXTRA_LARGE}
            </MenuItem>
          )}
        </NestedMenuItem>
        {!isKpi && (
          <NestedMenuItem
            label={t("CUSTOM_HOME_CARD_OPTIONS_COLOR")}
            parentMenuOpen={!!menuPosition}
          >
            <MenuItem>
              <ColorPicker
                value={newColor}
                defaultValue={muiTheme.palette.content.mainColor}
                onChange={(color) => {
                  handleChangeColorCard(`#${color.hex}`);
                }}
                hideTextfield={true}
                disableAlpha
                palette={{ default: muiTheme.palette.content.mainColor }}
                deferred
              />
            </MenuItem>
          </NestedMenuItem>
        )}

        <NestedMenuItem
          label={t("CUSTOM_HOME_CARD_MOVE")}
          parentMenuOpen={!!menuPosition}
        >
          <MenuItem
            onClick={(e) => handleMoveItem(e, INTRUCTIONS.ALLUP)}
            disabled={cardIndex === 0}
          >
            {t("CUSTOM_HOME_PSC_ALLUP")}
          </MenuItem>
          <MenuItem
            onClick={(e) => handleMoveItem(e, INTRUCTIONS.ALLDOWN)}
            disabled={cardIndex >= itemsLength - 1}
          >
            {t("CUSTOM_HOME_PSC_ALLDOWN")}
          </MenuItem>
        </NestedMenuItem>

        <MenuItem onClick={handleDeleteItem} disabled={itemsLength === 1}>
          {t("CUSTOM_HOME_CARD_OPTIONS_DELETE")}
          <Icon className={"fas fa-trash"} style={itemsIconStyles} />
        </MenuItem>
      </Menu>
    </div>
  );
};

export default OptionsCard;
